import gql from "graphql-tag";

export const GET_ALL_SUMMARY= gql`
query GetAllSummary($companyName: String, $limit: Int, $offset: Int, $searchText: String, $order: String, $orderBy: String, $title: String, $year: Int) {
    getAllSummary(companyName: $companyName, limit: $limit, offset: $offset, searchText: $searchText, order: $order, orderBy: $orderBy, title: $title, year: $year) {
    code
    success
    message
    count
    results
  }
}`;
